const toolExecutionAvgTime = {
  document_search: 120,
  risk_factors: 120,
  business_description: 120,
  financial_data_from_db: 10,
  earnings_summary: 40,
  topic_summary: 40,
  document_summary: 40,
  document_get_all_tables: 10,
  directory_search: 30,
  directory_summary: 20,
  calculator: 40,
};

export default toolExecutionAvgTime;
